import { createContext } from 'react'

export const CardClientContext = createContext()
